import React from 'react';
import { Link } from 'react-router-dom';
import * as api from '../api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { 
  SHOW_CART_MODAL,
  ADD_TO_CART, 
  ADD_TO_PRICING, 
  REMOVE_FROM_WISHLIST,
  REMOVE_FROM_CART,
  CLEAR_CART,
  SEND_CLEAR_CART,
  DECREMENT_QTY,
  CHANGE_QTY,
  GET_DELIVERY_COST
} from '../constants/action-types';

export const getDeliveryCost = (form, setDeliveryCost, setDeliveryCostErr) => dispatch => {
  api.getDeliveryCost(form, setDeliveryCost, setDeliveryCostErr).then(deliveryCost => {
      dispatch(receiveDeliveryCost(deliveryCost));
      return deliveryCost;
  })
}

export const receiveDeliveryCost = deliveryCost => ({
  type: GET_DELIVERY_COST,
  deliveryCost
});

export const addToCart = (product, qty = 1) => (dispatch) => {
  dispatch({ type: SHOW_CART_MODAL, product });
  dispatch({ type: ADD_TO_CART, product, qty });
}

export const addToPricing = (product, qty = 1) => (dispatch) => {
  dispatch({ type: ADD_TO_PRICING, product, qty });
}

export const quickAddToCart = (product, qty = 1) => (dispatch) => {
  const CustomToastWithLink = () => (
    <div style={{marginTop:'-10px'}}>
      <div className="text-center" style={{color:'#000',marginBottom:'5px'}}>Dodano do koszyka.&nbsp;</div>
      <div className="row">
        <div className="col-lg-6 col-6">
          <Link to="/koszyk" style={{background:'#ff6a00',color:'#fff',padding:'7px',display:'block',textAlign:'center'}}>Do kasy</Link>
        </div>
        <div className="col-lg-6 col-6">
          <span style={{background:'#06910a',color:'#fff',padding:'7px',display:'block',textAlign:'center',marginRight:'10px'}}>Kontynuuj</span>
        </div>
      </div>
    </div>
  );
  toast.success(CustomToastWithLink, {autoClose: 18000});
  dispatch({ type: ADD_TO_CART, product, qty });
}

export const addToCartAndRemoveWishlist = (product, qty) => (dispatch) => {
  toast.success("Produkt dodano do koszyka");
  dispatch({ type: ADD_TO_CART, product, qty });
  dispatch({ type: REMOVE_FROM_WISHLIST, product });
}

export const removeFromCart = (product) => (dispatch) => {
  toast.error("Produkt usunięto z koszyka");
  dispatch({ type: REMOVE_FROM_CART, product });
}

export const clearCart = (product) => (dispatch) => {
  toast.error("Koszyk wyczyszczony");
  dispatch({ type: CLEAR_CART, product });
}

export const sendClearCart = (product) => (dispatch) => {
  dispatch({ type: SEND_CLEAR_CART, product });
}

export const incrementQty = (product) => (dispatch) => {
  dispatch({ type: ADD_TO_CART, product, qty: 1 });
}

export const decrementQty = (product) => (dispatch) => {
  dispatch({ type: DECREMENT_QTY, product })
}

export const changeQty = (product, productQty) => (dispatch) => {
  dispatch({ type: CHANGE_QTY, product, qty: productQty })
}